import { AxiosResponse } from 'axios';
import { put, call, takeLatest, throttle } from 'redux-saga/effects';
import { ACTIVE_ORDERS } from '../../constants';

import {
  cartItemFailure,
  cartItemSuccess,
  failedPlaceOrder,
  successPlaceOrder,
} from './cartActions';
import { cartItem, placeOrder } from './cartAPI';
import { CART_ITEM_REQUEST, PLACE_ORDER_REQUEST } from './cartConstants';
import { Cart } from './cartModels';
import { successGetOrderDetail } from '../order/orderActions';
import { OrderDetail } from '../order/orderModels';
import { decryptJson } from '../../utils/react-ec-utils';
import { showErrorToast, showErrorToastDesktop } from '../../utils/toastUtils';
import { validateCoupon } from '../restaurant/restaurantAPI';
import { validateCouponFailure, validateCouponSuccess } from '../restaurant/restaurantAction';
import { logPrint } from '../auth/AuthAPI';



function* placeOrderSaga(action: any) {
  const isMobile = window.innerWidth <= 768;
  console.log("data payload",action.payload);
  
  try {
    let callBackFunc = null;
    let couponCode = '';

    if (
      action.payload?.details?.sagaCallBack != null &&
      typeof action.payload?.details?.sagaCallBack === 'function'
    ) {
      callBackFunc = action.payload?.details?.sagaCallBack;
      delete action.payload?.details?.sagaCallBack;
    }
    if (action.payload?.details?.couponCode != null && typeof action.payload?.details?.couponCode == 'string') {
      couponCode = action.payload?.details?.couponCode;
      delete action.payload?.details?.couponCode;
    }
    const payload = {
      customerId: action?.payload?.details?.customerId,
      couponCode: couponCode,
      locationId: action?.payload?.details?.locationId,
      orderTotal: action?.payload?.details?.orderTotal,
    };
  
  
    

    if (couponCode !== '') {
      const ValidCouponresponse: AxiosResponse = yield call(validateCoupon, payload as any);

      if (ValidCouponresponse?.status === 200) {
        const decryptedData = decryptJson(ValidCouponresponse.data.encryptedText);

        yield put(validateCouponSuccess(decryptedData));
        if (decryptedData?.status === 200) {
          const response: AxiosResponse = yield call(placeOrder, action.payload.details as Cart);

          if (response.status === 200) {
            const decryptedData: any = decryptJson(response?.data?.encryptedText);
              const printLog={
                localStorage: action.payload?.allStorage,
                cookies:action.payload?.cookies,
                orderId:decryptedData.orderId

               }

            yield call(logPrint, JSON.stringify(printLog)); 
            yield put(successPlaceOrder(decryptedData.orderId));
            yield put(successGetOrderDetail(decryptedData.order as OrderDetail));
            const activeOrder =
              localStorage.getItem('ACTIVE_ORDERS') &&
              JSON.parse(localStorage.getItem('ACTIVE_ORDERS') || '');
            if (!activeOrder) {
              let data = [
                {
                  orderId: decryptedData.orderId,
                  expiryTime: new Date().setHours(new Date().getHours() + 1),
                },
              ];
              localStorage.setItem(ACTIVE_ORDERS, JSON.stringify(data));
            } else {
              let data = [
                {
                  orderId: decryptedData.orderId,
                  expiryTime: new Date().setHours(new Date().getHours() + 1),
                },
                ...activeOrder,
              ];
              localStorage.setItem(ACTIVE_ORDERS, JSON.stringify(data));
            }
            if (callBackFunc != null) {
              callBackFunc(true, decryptedData);
            }
          } else {
            if (isMobile) {
              showErrorToast(response?.data?.message);
            } else {
              showErrorToastDesktop(response?.data?.message);
            }
            yield put(
              failedPlaceOrder(response?.data?.message ? response?.data?.message : 'Please Retry')
            );
            if (callBackFunc != null) {
              callBackFunc(false);
            }
          }
        }
      } else {
        yield put(validateCouponFailure(''));
      }
    } else {
      const response: AxiosResponse = yield call(placeOrder,  action.payload.details as Cart);

      if (response.status === 200) {
        const decryptedData: any = decryptJson(response?.data?.encryptedText);
        const printLog={
                localStorage: action.payload?.allStorage,
                cookies:action.payload?.cookies,
                orderId:decryptedData.orderId

               }

            yield call(logPrint, JSON.stringify(printLog));
        yield put(successPlaceOrder(decryptedData.orderId));
        yield put(successGetOrderDetail(decryptedData.order as OrderDetail));
        const activeOrder =
          localStorage.getItem('ACTIVE_ORDERS') &&
          JSON.parse(localStorage.getItem('ACTIVE_ORDERS') || '');
        if (!activeOrder) {
          let data = [
            {
              orderId: decryptedData.orderId,
              expiryTime: new Date().setHours(new Date().getHours() + 1),
            },
          ];
          localStorage.setItem(ACTIVE_ORDERS, JSON.stringify(data));
        } else {
          let data = [
            {
              orderId: decryptedData.orderId,
              expiryTime: new Date().setHours(new Date().getHours() + 1),
            },
            ...activeOrder,
          ];
          localStorage.setItem(ACTIVE_ORDERS, JSON.stringify(data));
        }
        if (callBackFunc != null) {
          callBackFunc(true, decryptedData);
        }
      } else {
        if (isMobile) {
          showErrorToast(response?.data?.message);
        } else {
          showErrorToastDesktop(response?.data?.message);
        }
        yield put(
          failedPlaceOrder(response?.data?.message ? response?.data?.message : 'Please Retry')
        );
        if (callBackFunc != null) {
          callBackFunc(false);
        }
      }
    }
  } catch (err: any) {
    yield put(failedPlaceOrder(err?.response?.data?.message));
  }
}

function* cartItemSaga(action: any) {
  try {
    const response: AxiosResponse = yield call(cartItem, action.payload);
    if (response.status === 200) {
      yield put(cartItemSuccess(response?.data));
    } else {
      yield put(cartItemFailure(response?.data));
    }
  } catch (err: any) {
    yield put(cartItemFailure(err));
  }
}

export default function* cartSaga() {
  yield throttle(5000, PLACE_ORDER_REQUEST, placeOrderSaga);
  yield takeLatest(CART_ITEM_REQUEST, cartItemSaga);
}
